import { ROLES } from "./../model/user";
import { AbilityBuilder, Ability } from "@casl/ability";
import adminAbility from "./adminAbility";
import groupAdminAbility from "./groupAdminAbility";
import memberAbility from "./memberAbility";

export default function defineAbilityFor(role = null) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  if (role == ROLES.ADMIN) {
    adminAbility(can, cannot);
  } else if (role == ROLES.GROUP_ADMIN) {
    groupAdminAbility(can, cannot);
  } else {
    memberAbility(can, cannot);
  }

  return build();
}
